<template>
  <div>
    <v-dialog v-model="isAdding" title="Add a new crypto rate" width="500px">
      <v-card>
        <v-card-title class="primary white--text d-flex justify-space-between">
          <span>Register A New Rate</span>
          <v-btn text icon dark @click="isAdding = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-container>
          <create-rate-form @rateCreated="rateCreated" />
        </v-container>
      </v-card>
    </v-dialog>
    <edit-crypto-rate
      :is-active.sync="isEditing"
      :cryptoRate="cryptoRate"
      @rateUpdated="rateUpdated"
    />
    <data-table
      :headers="headers"
      url="/api/v1/cryptoRates"
      title="Crypto Rates"
      item-key="id"
      :fields="fields"
      ref="table"
      searchable
    >
      <v-btn slot="action.icons" color="primary" tile @click="isAdding = true">
        <v-icon>mdi-plus</v-icon>
        New Rate
      </v-btn>
      <template slot="item.actions" slot-scope="{ item }">
        <v-btn small icon @click="destroyRate(item)">
          <v-icon>mdi-delete-outline</v-icon>
        </v-btn>
        <v-btn small icon @click="updateRate(item)">
          <v-icon>mdi-pencil-outline</v-icon>
        </v-btn>
      </template>
    </data-table>
  </div>
</template>
<script>
import CreateRateForm from "./createRateForm";
import EditCryptoRate from "./editRate";
export default {
  components: { CreateRateForm, EditCryptoRate },
  data() {
    return {
      isAdding: false,
      isEditing: false,
      cryptoRate: {},
      headers: {
        "crypto_currency.name": "Crypto Currency",
        "crypto_country.name": "Crypto Country",
        "local_currency.name": "Local currency",
        "reference_currency.name": "Reference currency",
        reference_to_local_rate: "Reference to Localπ Rate",
        reference_to_crypto_rate: "Reference to Crypto Rate",
        crypto_to_local_rate: "Crypto to Local Rate",
        min_crypto_amount: "Min Crypto Amount",
        max_crypto_amount: "Max Crypto Amount",
        actions: "Actions",
      },
      fields: {
        "crypto_currency.name": { type: "title" },
        reference_to_crypto_rate: { type: "currency" },
        reference_to_local_rate: { type: "currency" },
        crypto_to_local_rate: { type: "currency" },
      },
    };
  },
  methods: {
    rateCreated() {
      this.isAdding = false;
      // we could have just pushed the new rate to the fetch rates
      // but since a duplicate rate cannot be created on the server
      // we won't bother determining if it's a new or existing rate
      // even though I think we could by comparing the created_at and updated_at
      // we will just fetch a new copy of the rates
      this.$refs.table.fetchData().then(() => window.Notify.success("Rate was added successfully"));
    },
    updateRate(rate) {
      this.cryptoRate = rate;
      this.isEditing = true;
    },
    rateUpdated() {
      this.isEditing = false;
      this.$refs.table
        .fetchData()
        .then(() => window.Notify.success("Rate was updated successfully"));
    },
    destroyRate(rate) {
      Notify.confirm("Rate will be destroyed").then(() => {
        this.$http.delete(`api/v1/cryptoRates/${rate.id}`).then(() => {
          this.$refs.table.fetchData();
          window.Notify.success("Rate was deleted successfully");
        });
      });
    },
  },
};
</script>
